module.exports = __webpack_public_path__ + "static/media/C20-0416_BTBMS_Homepage_fr.7f81c163.jpg";